import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { Theme } from "src/app/models/auth/_models/user.model";
import { CompanyService } from "src/app/services/company.service";
import { MessagesService } from "src/app/services/service.index";

// import { getSyntheticLeadingComments } from "typescript";

@Component({
  selector: "app-company-settings-list",
  templateUrl: "company-settings-list.component.html",
  styleUrls: ["company-settings-list.component.scss"]
})
export class CompanySettingsListComponent implements OnInit {
  addButtonOptions: any;
  themesData: Theme[];
  loading = false; 

  constructor(
    private router: Router,
    public companyService: CompanyService,
    private _messagesService: MessagesService,
  ) {
    this.addButtonOptions = {
      icon: "plus",
      hint: "Nuevo",
      onClick: () => {
        this.addTheme();
      },
    };
  }

  ngOnInit(): void {
    this.getThemes();
  }

  gridHeight = () => {
    return Math.round(window.innerHeight / 1.3);
  };

  getThemes() {
    this.loading = true;
    this.companyService.getThemes().subscribe((result) => {
      this.loading = false;
      if (result.isSuccessful) {
        this.themesData = result.result;
      } else {
        this._messagesService.error(result.errorMessage);
      }
    });
  }

  addTheme() {
    this.router.navigate(["core/companysettings"]);
  }

  editThemeClick = (e: any) => {
    this.editTheme(e.row.data.id);
  };

  deleteThemeClick = (e: any) => {
    this.deleteTheme(e.row.data.code);
  };

  onRowDblClick(e: any) {
    this.editTheme(e.data.id);
  }

  editTheme(id: any) {
    this.router.navigate(["/companysettings"], {
      queryParams: {
        pId: id,
      },
    });

    
  }

  deleteTheme(id: string) {
    Swal.fire({
      title: "¿Está seguro?",
      text: "No se puede revertir esta operación",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1bc5bd",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.companyService.deleteTheme(id).subscribe((result) => {
          if (result.isSuccessful) {
            this._messagesService.success("Eliminado!");
            this.getThemes();
          } else {
            this._messagesService.error(result.errorMessage);
          }
        });
      }
    });
  }
}
